import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const brand = defineStyle({
  bg: "transparent",
  borderWidth: "1px",
  borderColor: "black",
  color: "black",
  _hover: {
    bg: "primary.200",
    borderColor: "primary.200",
    color: "white",
  },
});

const ideal = defineStyle({
  bg: "primary.200",
  color: "white",
  _hover: {
    bg: "black",
    color: "white",
  },
});

const primary = defineStyle({
  bg: "black",
  border: "1px solid black",
  color: "white",
  borderRadius: "20px",
  _hover: {
    backgroundColor: "transparent",
    color: "black",
  },
});

const secondary = defineStyle({
  bg: "white",
  borderWidth: "2px",
  borderRadius: "8px",
  color: "primary.200",
  _hover: {
    backgroundColor: "black",
    color: "white",
  },
});

const outline = defineStyle({
  bg: "transparent",
  borderColor: "white",
  borderWidth: "1px",
  color: "white",
  _hover: {
    backgroundColor: "white",
    color: "black",
  },
});

const link = defineStyle({
  bg: "transparent",
  color: "primary.200",
  // _hover: {
  //   color: "black",
  // },
});

const lg = defineStyle({
  height: "50px",
});

const md = defineStyle({
  height: "40px",
});

export const Button = defineStyleConfig({
  baseStyle: {},
  sizes: {
    lg,
    md,
  },
  variants: {
    brand,
    ideal,
    primary,
    link,
    secondary,
    outline,
  },
  defaultProps: {},
});

export const BUTTON_VARIANTS = {
  BRAND: "brand",
  IDEAL: "ideal",
  GHOST: "ghost",
  LINK: "link",
  OUTLINE: "outline",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SOLID: "solid",
  UNSTYLED: "unstyled",
};
